export const Blog = [
  {
    path: '/blogs/:app_module_id',
    name: 'blogs.index',
    component: () => import('@/pages/Blog/BlogModule')
  },
  {
    path: '/blogs/:app_module_id/post/:id/edit/',
    name: 'blogs.edit',
    component: () => import('@/pages/Blog/BlogEdit')
  },
  {
    path: '/blogs/:app_module_id/post/:id',
    name: 'blogs.item',
    component: () => import('@/pages/Blog/BlogPage')
  }
]
